import { logofaded, coverImage } from "../../assets/images/images";
import Footer from "../../components/Footer/Footer";
import Topbar from "../../components/Topbar/Topbar";
import "./resetPassword.css";
// Reuse the exact same auth-shell styles as ForgotPassword / Login
import "../ForgetPassword/ForgotPassword.css";

import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import API from "../../API";
import { useLocation } from "react-router-dom";
import {
  FaLock, FaKey, FaEye, FaEyeSlash, FaArrowLeft, FaExclamationCircle,
  FaEnvelopeOpenText, FaShieldAlt
} from "react-icons/fa";

export default function ResetPassword() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [seepsw, setSeepsw] = useState(false);
  const [seepsw2, setSeepsw2] = useState(false);
  const [formData, setFormData] = useState({ newPassword: '', confirmPassword: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const changeLanguage = (lng) => {
    if (i18n.language === lng) return;
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
    window.location.reload();
  };
  const isFr = i18n.language === 'fr';
  const isAr = i18n.language === 'ar';
  const isRTL = isAr;

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const email = queryParams.get('email');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrorMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (formData.newPassword.length < 8) {
      setErrorMessage(t("resetPassword.password_length_error"));
      return;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessage(t("resetPassword.password_match_error"));
      return;
    }

    setLoading(true);
    try {
      const response = await API.post(
        `/auth/reset-password/${token}`,
        { newPassword: formData.newPassword, email }
      );
      if (response.status === 201) {
        window.location.href = '/login';
      }
    } catch (error) {
      console.error("Reset password error:", error);
      setErrorMessage(error.response?.data?.message || t("resetPassword.server_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Page_login" dir={isRTL ? "rtl" : "ltr"}>
      <Topbar />

      <div className="auth-langbar" role="group" aria-label="language">
        <button type="button" className={`auth-langbtn ${isFr ? 'active' : ''}`} onClick={() => changeLanguage('fr')} aria-pressed={isFr}>FR</button>
        <button type="button" className={`auth-langbtn ${isAr ? 'active' : ''}`} onClick={() => changeLanguage('ar')} aria-pressed={isAr}>AR</button>
      </div>

      <main className="auth-shell">
        <aside className="auth-brand" style={{ backgroundImage: `url(${coverImage})` }}>
          <div className="auth-brand__scrim" />
          <div className="auth-brand__content">
            <div className="auth-brand__row">
              <div className="auth-brand__logo">
                <img src={logofaded} alt="Protour" />
              </div>
              <h2 className="auth-brand__heading">Set a new password</h2>
            </div>
            <p className="auth-brand__sub">
              Choose a new password for your account. Make sure it's at least 8 characters long.
            </p>

            <ul className="auth-features">
              <li>
                <span className="auth-features__ico"><FaEnvelopeOpenText /></span>
                <div>
                  <strong>Secure reset link</strong>
                  <span>Your password reset link is single-use and expires automatically.</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaLock /></span>
                <div>
                  <strong>Strong password</strong>
                  <span>Use at least 8 characters, mixing letters and numbers for safety.</span>
                </div>
              </li>
              <li>
                <span className="auth-features__ico"><FaShieldAlt /></span>
                <div>
                  <strong>Protect your account</strong>
                  <span>We'll never ask for your password by email — only through this page.</span>
                </div>
              </li>
            </ul>
          </div>
        </aside>

        <section className="auth-form-wrap">
          <div className="auth-card">
            <div className="auth-card__head">
              <span className="auth-pill">
                <span className="auth-pill__dot"><FaKey /></span> Reset
              </span>
              <h1 className="auth-card__title">{t("resetPassword.title")}</h1>
              <p className="auth-card__sub">
                {email ? `Resetting password for ${email}` : 'Enter your new password below.'}
              </p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <label className="auth-label">
                  <FaLock className="auth-label__ico" />
                  <span>{t("resetPassword.newPassword_label")}</span>
                </label>
                <div className="auth-input-group">
                  <input
                    className="auth-input"
                    type={seepsw ? "text" : "password"}
                    placeholder={t("resetPassword.newPassword_placeholder")}
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                    minLength={8}
                  />
                  <button type="button" className="auth-input-action" onClick={() => setSeepsw((s) => !s)} aria-label="toggle password">
                    {seepsw ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div className="auth-field">
                <label className="auth-label">
                  <FaLock className="auth-label__ico" />
                  <span>{t("resetPassword.confirmPassword_label")}</span>
                </label>
                <div className="auth-input-group">
                  <input
                    className="auth-input"
                    type={seepsw2 ? "text" : "password"}
                    placeholder={t("resetPassword.confirmPassword_placeholder")}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    minLength={8}
                  />
                  <button type="button" className="auth-input-action" onClick={() => setSeepsw2((s) => !s)} aria-label="toggle password">
                    {seepsw2 ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {errorMessage && (
                <div className="auth-banner auth-banner--err">
                  <FaExclamationCircle />
                  <p>{errorMessage}</p>
                </div>
              )}

              <button type="submit" className="auth-btn auth-btn--primary" disabled={loading}>
                <FaKey /> {t("resetPassword.reset_button")}
              </button>
            </form>

            <p className="auth-foot">
              <a className="auth-home" href="/login">
                <FaArrowLeft /> Back to login
              </a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
